import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { WarningIcon, WarningIconType } from '../../../components/svgs/icons/WarningIcon';
import { Button } from '../../../components-v2/Button';
import {
	Dialog,
	DialogBody,
	DialogFooter,
	DialogHeader,
	DialogPopup,
	DialogTitle,
} from '../../../components-v2/Dialog';
import { THEME } from '../../../components-v2/Theme/theme';

interface CustomizeComplianceReviewedModalProps {
	isOpen: boolean;
	onRequestClose: () => void;
	onConfirm: () => void;
	isConfirmDisabled?: boolean;
}

export const CustomizeComplianceReviewedModal: React.FC<CustomizeComplianceReviewedModalProps> = ({
	isOpen,
	onRequestClose,
	onConfirm,
	isConfirmDisabled,
}) => {
	const onOpenChange = (open: boolean) => {
		if (!open) {
			onRequestClose();
		}
	};

	return (
		<Dialog onOpenChange={onOpenChange} open={isOpen}>
			<DialogPopup>
				<DialogHeader styles={[styleSheet.header]}>
					<WarningIcon type={WarningIconType.Red} />
					<DialogTitle>Customize reviewed content?</DialogTitle>
				</DialogHeader>
				<DialogBody>
					<p className={css(styleSheet.description)}>
						This content was approved as written. Customizing it with AI creates new copy that is no longer covered by
						that review, and it may need to be re-approved before it goes out.
					</p>
				</DialogBody>
				<DialogFooter>
					<Button variant='secondary' onClick={onRequestClose}>
						Cancel
					</Button>
					<Button variant='destructive' onClick={onConfirm} disabled={isConfirmDisabled}>
						Customize anyway
					</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
};

const styleSheet = StyleSheet.create({
	header: {
		alignItems: 'center',
		flexDirection: 'row',
		gap: THEME.spacing.sm,
	},
	description: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
});
